export default {
    log_event: function (item, event, ignoreLogAttribute, $dataElement, additionalUrlInfo) {
        if (ignoreLogAttribute || $dataElement.data("ga-log")) {
            var path_name = window.location.pathname;
            if (additionalUrlInfo) {
                path_name = path_name + additionalUrlInfo;
            }
            var label = "USAJOBS_" + path_name + window.location.search + "_" + $dataElement.data("ga-label");
            $dataElement.data('ga-log', false);
            if (window.ga && ga.create) {
                var trackers = ga.getAll();
                if (trackers && trackers.length > 0) {
                    var trackerName = trackers[0].get('name');
                    ga(trackerName + '.send', 'event', item, event, label);
                }
            }
        } else {
            $dataElement.data('ga-log', true);
        }
    },
    simple_log_event: function (item, event, label) {
        if (window.ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                var eventLabel = window.location.hostname + "_" + label;
                ga(trackerName + '.send', 'event', "USAJOBS_" + item, event, eventLabel);
            }
        }
    },
    log_event_no_hostname: function (item, event, label) {
        if (window.ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                ga(trackerName + '.send', 'event', "USAJOBS_" + item, event, label);
            }
        }
    },
    log_event_with_timeout: function (item, event, label, counter) {
        counter = counter == null ? 0 : counter;
        if (window.ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                ga(trackerName + '.send', 'event', "USAJOBS_" + item, event, label);
            }
        } else {
            if (counter < 10) {
                counter++;
                setTimeout(function () {
                    this.log_event_with_timeout(item, event, label, counter);
                }.bind(this), 500)
            }
        }
    },
    log_page_view: function (page) {
        if (window.ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                ga(trackerName + '.set', 'page', page);
                ga(trackerName + '.send', 'pageview');
            }
        }
    },
    getUserObject() {
        let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
        return (userObject.UniqueSearch === undefined || userObject.UniqueSearch === null) ?
            {
                "UniqueSearch": { "Id": 0, "Keyword": '', "PreviousKeyword": null, "filters": null },
                "IsAuthenticated": false
            }
            : userObject;
    },
    getDataLayerObjectForSearch(urlObject, userObject, event, setFilters = true) {
        const SearchTermParams = ['k', 'soc', 'jt', 'j', 'a', 'Keyword', 'IsAuthenticated', 'UniqueSearchID', 'Page', 'ResultsPerPage'];
        let dataLayerObject = {
            "event": event,
            "searchId": userObject.UniqueSearch.Id,
            "authenticated": userObject.IsAuthenticated,
            "search_term": urlObject['Keyword'] ?? "",
            "filters": { "filterId": userObject.UniqueSearch.filters["filterId"] ?? crypto.randomUUID() },
            "total_results": urlObject.TotalResults
        };
        for (let key in urlObject) {
            if (SearchTermParams.indexOf(key) > -1) {
                continue;
            }
            let value = urlObject[key];
            if (value !== undefined && value !== null && ((Array.isArray(value) && value.length > 0) || value.toString().length > 0)) {
                dataLayerObject.filters[key] = value;
            }
        }
        if (setFilters === true) {
            userObject.UniqueSearch["filters"] = dataLayerObject.filters;
            userObject.UniqueSearch.filters["filterId"] = crypto.randomUUID();
            dataLayerObject.filters.filterId = userObject.UniqueSearch.filters.filterId;
            sessionStorage.setItem("userObject", JSON.stringify(userObject));
        }
        return dataLayerObject;
    },
    log_search: function (urlObject) {
        if (window.dataLayer) {
            window.dataLayer.push(this.getDataLayerObjectForSearch(urlObject, this.getUserObject(), "view_search_results", true));
            console.debug(dataLayer);
        }
    },
    log_search_filter_interaction: function (urlObject) {
        if (window.dataLayer) {
            const userObject = this.getUserObject();
            let dataLayerObject = this.getDataLayerObjectForSearch(urlObject, userObject, "filter_interaction", false);
            let filterId = userObject.UniqueSearch.filters.filterId;
            
            dataLayerObject["filter_added"] = false;
            dataLayerObject["filter_removed"] = false;
            dataLayerObject["filters_changed"] = [];

            for (const prop in userObject.UniqueSearch.filters) {
                if (prop === 'filterId') {
                    continue;
                }
                const dataLayerFilter = dataLayerObject.filters[prop];
                const uoFilter = userObject.UniqueSearch.filters[prop];
                if (dataLayerFilter === undefined || (Array.isArray(dataLayerFilter) && dataLayerFilter.length < uoFilter.length)) {
                    dataLayerObject.filter_removed = true;
                    if (dataLayerObject.filters_changed?.indexOf(prop) === -1) {
                        dataLayerObject.filters_changed.push(prop);
                    }
                }
                else if (dataLayerFilter != undefined && !Array.isArray(dataLayerFilter) && uoFilter != dataLayerFilter && dataLayerObject.filters_changed?.indexOf(prop) === -1) {
                    dataLayerObject.filters_changed.push(prop);
                }
            }
            
            for (const prop in dataLayerObject.filters) {
                if (prop === 'filterId') {
                    continue;
                }
                const dataLayerFilter = dataLayerObject.filters[prop];
                const uoFilter = userObject.UniqueSearch.filters[prop];
                if (uoFilter === undefined || (Array.isArray(uoFilter) && dataLayerFilter.length > uoFilter.length)) {
                    dataLayerObject.filter_added = true;
                    if (dataLayerObject.filters_changed?.indexOf(prop) === -1) {
                        dataLayerObject.filters_changed.push(prop);
                    }
                }
                else if (uoFilter != undefined && !Array.isArray(uoFilter) && uoFilter != dataLayerFilter && dataLayerObject.filters_changed?.indexOf(prop) === -1) {
                    dataLayerObject.filters_changed.push(prop);
                }
            }

            if (dataLayerObject.filters_changed.length > 0) {
                filterId = crypto.randomUUID();
                userObject.UniqueSearch.filters = dataLayerObject.filters;
                userObject.UniqueSearch.filters.filterId = filterId;
                dataLayerObject.filters.filterId = filterId;
                sessionStorage.setItem('userObject', JSON.stringify(userObject));
                window.dataLayer.push(dataLayerObject);
                console.debug(dataLayer);
            }
        }
    },
    log_search_conversion_event: function (userObject, eventName) {
        if (window.dataLayer && userObject && userObject.UniqueSearch) {
            const dataLayerObject = {
                event: eventName,
                searchId: userObject.UniqueSearch.Id,
                filterId: userObject.UniqueSearch.filters.filterId,
                conversionId: userObject.SearchResults.ConversionId,
                selectedDocumentId: userObject.SearchResults.SelectedDocumentId,
                selectedDocumentPage: userObject.SearchResults.Results.PageSets[0].Page,
                selectedDocumentRank: userObject.SearchResults.Results.Items.indexOf(userObject.SearchResults.SelectedDocumentId) + 1
            }
            window.dataLayer.push(dataLayerObject);
            console.debug(dataLayer);
        }
    }
};
